import React, { PropsWithChildren } from 'react';

import { Box, Card, CardContent, Typography } from '@mui/material';

interface Props {
  title: string;
  description?: string;
}

export default function NativeTourCard({ title, description, children }: PropsWithChildren<Props>) {
  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="subtitle1" fontWeight="medium">
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
        <Box mt={2}>{children}</Box>
      </CardContent>
    </Card>
  );
}
